export default __webpack_public_path__ + "static/media/glitch18.fdf488ab.png";